import React, { useEffect, useState } from "react";
import { unstable_batchedUpdates } from "react-dom";
import { getPlaces, getInspections } from "../../services/inspectionService";
import InspectionRow from "./InspectionRow";
import Select from "react-select";
import { FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import { ScaleLoader } from "react-spinners";
import Pagination from "../Pagination";

export function paginate(items, pageNumber, pageSize) {
  const startIndex = (pageNumber - 1) * pageSize;
  return items.slice(startIndex, items.length).slice(0, pageSize);
}

const threeMonthsAgo = () => {
  const d = new Date();
  d.setMonth(d.getMonth() - 3);
  return d.toISOString().split("T")[0];
};

const Inspection = () => {
  const [inspectionParams, setInspectionParams] = useState({
    plate: null,
    place: null,
    status: "waiting_for_inspection",
    size: 10,
    date_from: threeMonthsAgo(),
    date_to: null,
  });
  const [inspections, setInspections] = useState([]);
  const [allInspections, setAllInspections] = useState([]);
  const [places, setPlaces] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginationParams, setPaginationParams] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
  });

  useEffect(() => {
    getPlaces().then((response) => {
      if (response && response.data && response.data.data) {
        setPlaces(response.data.data);
        if (response.data.data[0]) {
          const firstPlace = response.data.data[0].attributes.id;
          const initialParams = { ...inspectionParams, place: firstPlace };
          setInspectionParams(initialParams);
          fetchInspections(initialParams);
        }
      }
    });
  }, []);

  const fetchInspections = async (params) => {
    setLoading(true);
    setInspections([]);
    setAllInspections([]);
    try {
      const response = await getInspections(
        params.plate,
        params.place,
        params.status,
        0,
        100000,
        params.date_from,
        params.date_to
      );
      const all = response.data.data || [];
      const pSize = params.size < all.length ? params.size : all.length;
      const paginated = paginate(all, 1, pSize);
      unstable_batchedUpdates(() => {
        setPaginationParams({ currentPage: 1, pageSize: pSize, count: all.length });
        setAllInspections(all);
        setInspections(paginated);
        setLoading(false);
      });
    } catch (e) {
      console.error("fetchInspections error", e);
      setLoading(false);
    }
  };


  const handleSearch = () => {
    fetchInspections(inspectionParams);
  };

  const handleChange = (e) => {
    setInspectionParams({ ...inspectionParams, [e.target.name]: e.target.value });
  };

  const handleChangePlace = (e) => {
    setInspectionParams({ ...inspectionParams, place: e.value });
  };

  const handleChangeStatus = (e) => {
    setInspectionParams({ ...inspectionParams, status: e.value });
  };

  const placeOptions = places.map((place) => {
    const d = place.attributes;
    return { value: d.id, label: d.name };
  });

  const statusOptions = [
    { value: "waiting_for_inspection", label: "Odottaa tarkastusta" },
    { value: "during_inspection", label: "Tarkastuksessa" },
    { value: "waiting_for_acceptance", label: "Tarkastus valmis" },
    { value: "accepted", label: "Hyväksytty" },
  ];

  const handlePageChange = (page) => {
    setPaginationParams({ ...paginationParams, currentPage: page });
    const paginated = paginate(allInspections, page, paginationParams.pageSize);
    setInspections(paginated);
  };

  return (
    <main>
      <div className="container">
        <div className="w-100 d-flex align-items-center justify-content-end my-3"></div>
        <h1 className="fs-3 text-primary my-3">Tarkastukseen tulevat</h1>
        <div className="w-100 border rounded-3 p-3 mt-3">
          {/* Row 1: Toimipiste / Tilanne / Kpl/sivu / Uusi Tarkastus */}
          <div className="row align-items-end">
            <div className="col-sm-3 col-md-3">
              <div className="mb-3">
                <label className="form-label">Toimipiste</label>
                <Select
                  name="place"
                  options={placeOptions}
                  onChange={handleChangePlace}
                  placeholder="Toimipiste..."
                  isSearchable
                  value={placeOptions.filter(
                    (option) => option.value === inspectionParams.place
                  )}
                />
              </div>
            </div>
            <div className="col-sm-3 col-md-3">
              <div className="mb-3">
                <label className="form-label">Tilanne</label>
                <Select
                  name="status"
                  options={statusOptions}
                  onChange={handleChangeStatus}
                  placeholder="Tilanne..."
                  isSearchable
                  value={statusOptions.filter(
                    (option) => option.value === inspectionParams.status
                  )}
                />
              </div>
            </div>
            <div className="col-sm-2 col-md-2">
              <div className="mb-3">
                <label className="form-label">Kpl/sivu</label>
                <select
                  name="size"
                  className="form-select"
                  onChange={handleChange}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="40">40</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
            </div>
            <div className="col-sm-4 col-md-4 text-end">
              <div className="mb-3">
                <Link
                  to={{
                    pathname: "/admin/inspection_start",
                    state: {
                      displayType: "new",
                      params_place: inspectionParams.place,
                      params_plate: inspectionParams.plate,
                      placeOptions: placeOptions,
                      places: places,
                    },
                  }}
                  className="btn btn-primary text-white fs-14 rounded-pill me-2 text-nowrap"
                >
                  <span className="fs-12 me-1">
                    <FaPlus />
                  </span>
                  <span className="me-1">Uusi Tarkastus</span>
                </Link>
              </div>
            </div>
          </div>
          {/* Row 2: Päivämäärä / Rekisterinumero / Hae */}
          <div className="row align-items-end">
            <div className="col-12 col-lg-5">
              <div className="mb-3">
                <label className="form-label">Päivämäärä</label>
                <div className="d-flex flex-row gap-2">
                  <input
                    type="date"
                    className="form-control no-shadow-btn"
                    name="date_from"
                    onChange={handleChange}
                    value={inspectionParams.date_from || ""}
                  />
                  <input
                    type="date"
                    className="form-control no-shadow-btn"
                    name="date_to"
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-8 col-lg-4">
              <div className="mb-3">
                <label className="form-label">Tapahtuman sop. nro / Rek.nro</label>
                <input
                  type="text"
                  className="form-control no-shadow-btn"
                  name="plate"
                  onChange={handleChange}
                  value={inspectionParams["plate"] || ""}
                />
              </div>
            </div>
            <div className="col-sm-4 col-lg-3">
              <div className="mb-3">
                <button
                  className="btn btn-primary text-white rounded-pill px-4 w-100"
                  onClick={handleSearch}
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                    />
                  ) : (
                    "Hae"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="w-100 my-3 border rounded-3 p-3">
          <div className="table-responsive">
            <table className="table table-borderless table-hover">
              <thead>
                <tr>
                  <th style={{ width: "60px" }}>{allInspections.length}</th>
                  <th></th>
                  <th>Sop.nro/Rek.</th>
                  <th>Make</th>
                  <th>Model</th>
                  <th>Toimipiste</th>
                  <th>Tarkistus vaihe</th>
                  <th>Tilanne</th>
                  <th></th>
                  <th>Tarkastuspäivä</th>
                </tr>
              </thead>
              <tbody className="fs-12">
                {loading ? (
                  <tr>
                    <td colSpan="10">
                      <div className="w-100 text-center py-4">
                        <ScaleLoader color={"blue"} loading={loading} size={150} />
                      </div>
                    </td>
                  </tr>
                ) : (
                  inspections.map((inspection, idx) => (
                    <InspectionRow
                      key={idx}
                      inspection={inspection}
                      setInspections={setInspections}
                      inspections={inspections}
                    />
                  ))
                )}
              </tbody>
            </table>
            <div className="my-3">
              <Pagination
                itemsCount={paginationParams.count}
                pageSize={paginationParams.pageSize}
                currentPage={paginationParams.currentPage}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Inspection;
